import React from "react";
import { Link } from "react-router-dom";
import ProductsData from "./ProductData";
import ProductCard from "./ProductCard";

function Products() {
  return (
    <div className="products-page">

      {/* Product Hero */}
      <section className="products-hero">
        <div className="products-hero-glow products-glow-one"></div>
        <div className="products-hero-glow products-glow-two"></div>

        <div className="container">
          <div className="row align-items-center">

            <div
              className="col-lg-8 col-md-10 col-12"
              data-aos="fade-up"
            >
              <div className="products-hero-content">

                <span className="products-eyebrow">
                  DNK SOFTWARE PRODUCTS
                </span>

                <h1>
                  Software That
                  <span> Powers Businesses.</span>
                </h1>

                <p>
                  Discover powerful products built by DNK Software
                  to simplify operations, connect teams and help
                  businesses grow.
                </p>

                <div className="products-hero-buttons">
                  <a
                    href="#our-products"
                    className="theme-btn"
                  >
                    Explore Products
                    <i className="icon-arrow-right-1"></i>
                  </a>

                  <Link
                    to="/contact"
                    className="products-secondary-btn"
                  >
                    Talk to Our Team
                  </Link>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>


      {/* Products */}
      <section
        id="our-products"
        className="products-section section-padding"
      >
        <div className="container">

          <div
            className="row text-center mb-50"
            data-aos="fade-up"
          >
            <div className="col-lg-8 col-12 offset-lg-2">

              <div className="section-title">
                <p>Our Products</p>

                <h1>
                  Technology Built For
                  Modern Businesses
                </h1>
              </div>

              <p className="mt-20">
                Explore our growing ecosystem of software products
                designed to make business simpler, smarter and more
                connected.
              </p>

            </div>
          </div>


          {/* <div className="row g-4"> */}
          <div className="products-showcase-list">

            {ProductsData.map((product, index) => (
              <ProductCard
                key={product.id}
                product={product}
                index={index}
              />
            ))}

          </div>

        </div>
      </section>


      {/* Why DNK */}
      <section className="products-benefits section-padding">

        <div className="container">

          <div className="row align-items-center">

            <div
              className="col-lg-5 col-12"
              data-aos="fade-right"
            >
              <div className="section-title">

                <p>Why DNK Products</p>

                <h1>
                  Built Around
                  Your Business.
                </h1>

              </div>

              <p className="mt-20">
                Our products combine modern technology with
                practical business workflows to help teams
                work better and make faster decisions.
              </p>
            </div>


            <div className="col-lg-7 col-12">

              <div className="row">

                <div
                  className="col-md-4 col-12"
                  data-aos="fade-up"
                >
                  <div className="product-benefit">
                    <div className="benefit-icon">
                      <i className="fas fa-bolt"></i>
                    </div>

                    <h4>Faster</h4>

                    <p>
                      Simplify everyday business operations.
                    </p>
                  </div>
                </div>


                <div
                  className="col-md-4 col-12"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="product-benefit">
                    <div className="benefit-icon">
                      <i className="fas fa-link"></i>
                    </div>

                    <h4>Connected</h4>

                    <p>
                      Keep teams, data and workflows connected.
                    </p>
                  </div>
                </div>


                <div
                  className="col-md-4 col-12"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div className="product-benefit">
                    <div className="benefit-icon">
                      <i className="fas fa-brain"></i>
                    </div>

                    <h4>Intelligent</h4>

                    <p>
                      Use technology to make smarter decisions.
                    </p>
                  </div>
                </div>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* CTA */}
      <section className="products-cta">

        <div className="container">

          <div
            className="products-cta-inner"
            data-aos="zoom-in"
          >

            <div>
              <span>READY TO GET STARTED?</span>

              <h2>
                Let's Build Something
                Better Together.
              </h2>
            </div>

            <Link
              to="/contact"
              className="theme-btn"
            >
              Contact Us
              <i className="icon-arrow-right-1"></i>
            </Link>

          </div>

        </div>

      </section>

    </div>
  );
}

export default Products;